export const offerings = [
  {
    label: "Digital products we build",
    items: [
      {
        icon: "pulse",
        text: "Nursing One",
        desc: "Patient management & billing for clinics",
        href: "/products/patient-management",
      },
      {
        icon: "box",
        text: "Dialysis inventory management",
        desc: "Track consumables, stock levels and reorders",
        href: "/products/dialysis-inventory",
      },
    ],
  },
  {
    label: "Online presence we manage",
    items: [
      {
        icon: "pin",
        text: "Google Business Profile & Maps",
        desc: "Get found and chosen by nearby customers",
        href: "/services#service-gbp",
      },
      {
        icon: "code",
        text: "Showcase websites",
        desc: "Fast, simple sites that present your business well",
        href: "/our-clients",
      },
    ],
  },
];
